// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API,
  authDomain: "united-for-her.firebaseapp.com",
  databaseURL: "https://united-for-her.firebaseio.com",
  projectId: "united-for-her",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: "813716010162",
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: "G-1SPV63X0XH",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
